module.exports = __webpack_public_path__ + "img/cloud-bolt-sun.7d6f041e.svg";